import React from 'react'
import { Checkbox } from 'components/forms'
import { Label } from './styled'
import { ReactComponent as Top } from 'components/Tree/icons/top.svg'
import { StyledInnerElement, PositionedColorTag, RightSideContainer, ToggleOpenButton } from 'components/Tree/nodes/common'

const Shop = ({ index, children, label, status, toggleActive, isOpened, toggleOpened, isSelected, isCheckable, leafCount, activeLeafCount, handleSelect, showLeafCount, checkOnSelect }) => (
	<li style={{ background: index % 2 === 0 ? 'unset' : '#eee' }}>
		<StyledInnerElement onClick={handleSelect} isSelectable={checkOnSelect} style={{ paddingLeft: isOpened ? '24px' : '38px' }} noBorder noBackground>
			{checkOnSelect && <PositionedColorTag color={isSelected ? '#3c4e5a' : null}/>}
			{isOpened && <Top style={{ marginTop: 'auto', marginRight: '5px' }}/>}
			{isCheckable ? <Checkbox
				noForm
				stopPropagation={true}
				onChange={toggleActive}
				checked={status === 'ACTIVE'}
				indeterminate={status === 'PARTIAL_ACTIVE'}
				field='active'
				label={label}
				inline
			/> : <Label>{label}</Label>}
			<RightSideContainer>
				{showLeafCount && <h5>{`${activeLeafCount}/${leafCount}`}</h5>}
				<ToggleOpenButton isOpened={isOpened} toggleOpened={toggleOpened}/>
			</RightSideContainer>
		</StyledInnerElement>
		{isOpened && <ul>
			{children}
		</ul>}
	</li>
)

export default Shop
